import { PaletteColor } from '@mui/material'

declare module '@mui/material/styles' {
	interface Palette {
		gameBuildingBlocks: Palette['primary']
	}

	interface PaletteOptions {
		gameBuildingBlocks?: PaletteOptions['primary']
	}
}

declare module '@mui/material/Alert' {
	interface AlertPropsColorOverrides {
		gameBuildingBlocks: true
	}
}

export const gameBuildingBlocksColor = {
	main: '#CD435E',
	light: '#FFBBC8',
} as PaletteColor
